import { render } from "./RankTile.vue?vue&type=template&id=c56261a8&scoped=true"
import script from "./RankTile.vue?vue&type=script&lang=js"
export * from "./RankTile.vue?vue&type=script&lang=js"

import "./RankTile.vue?vue&type=style&index=0&id=c56261a8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56261a8"]])

export default __exports__